/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newpatient_Privacypolicylink3Inputs */

const en_newpatient_privacypolicylink3 = /** @type {(inputs: Newpatient_Privacypolicylink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const fr_newpatient_privacypolicylink3 = /** @type {(inputs: Newpatient_Privacypolicylink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politique de confidentialité`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Newpatient_Privacypolicylink3Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const newpatient_privacypolicylink3 = /** @type {((inputs?: Newpatient_Privacypolicylink3Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newpatient_Privacypolicylink3Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_newpatient_privacypolicylink3(inputs)
	return fr_newpatient_privacypolicylink3(inputs)
});
export { newpatient_privacypolicylink3 as "newPatient_privacyPolicyLink" }